import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Happy Birthday Tisha',
    description: 'Ek chhota sa surprise, sirf Tisha ke liye. Hamari story, yaadein, khel aur dil se likha ek khat.',
    url: getOrigin()
}

/* Her birthday, used by the countdown in the hero. Month is 1 to 12. */
export const BIRTHDAY = {
    month: 11,
    day: 5
}
